module.exports = __webpack_public_path__ + "static/media/left-side.4e55ba20.png";